import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit {

  constructor() { }

  @Input()
  public color: 'black' | 'white' = 'black';

  @Input()
  public size: 'small' | 'default' = 'default';

  ngOnInit(): void {
  }

}
